import { createStructuredSelector } from 'reselect';
import { selectAccountID } from '../../../../selectors/globalSelectors';
import { getCarouselData } from '../../../../CommonComponents/Carousel/selectors';

/** Contribitions overview State Selector */
const getContributionDashboardStates = (state) => state.contributionsDashboard;

/** Messaging State Selector */
const getMessagingStates = (state) => state.messaging;

/** Account Selectors */

const getAccount = (state) => {
  const { accountData } = getContributionDashboardStates(state);
  return accountData;
};

const getAccountData = (state) => {
  const { data } = getAccount(state);
  return data;
};

const getAccountLoadingStatus = (state) => {
  const { isLoading } = getAccount(state);
  return isLoading;
};

const getAccountError = (state) => {
  const { error } = getAccount(state);
  return error;
};

/** Account Selectors */

/** Pending Contributions selectors */

const getPendingContributions = (state) => {
  const { pendingContributions } = getContributionDashboardStates(state);
  return pendingContributions;
};

const getPendingContributionsData = (state) => {
  const { data } = getPendingContributions(state);
  return data;
};

const getPendingContributionsLoadingStatus = (state) => {
  const { isLoading } = getPendingContributions(state);
  return isLoading;
};

/** Completed Contributions selectors */

const getCompletedContributions = (state) => {
  const { completedContributions } = getContributionDashboardStates(state);
  return completedContributions;
};

const getCompletedContributionsData = (state) => {
  const { data } = getCompletedContributions(state);
  return data;
};

const getCompletedContributionsLoadingStatus = (state) => {
  const { isLoading } = getCompletedContributions(state);
  return isLoading;
};

/** Completed Contributions selectors */

/** Tax Receipts selectors */

const getTaxReceipts = (state) => {
  const { taxReceipts } = getContributionDashboardStates(state);
  return taxReceipts;
};

const getTaxReceiptsData = (state) => {
  const { data } = getTaxReceipts(state);
  return data;
};

const getTaxReceiptsLoadingStatus = (state) => {
  const { isLoading } = getTaxReceipts(state);
  return isLoading;
};

/** Tax Receipts selectors */

/** Lazy loading selectors */

const getLazyLoadingStatus = (state) => {
  const { isLazyLoading } = getContributionDashboardStates(state);
  return isLazyLoading;
};

const getPendingDataAvailableStatus = (state) => {
  const { dataAvailableForNextRequest } = getPendingContributions(state);
  return dataAvailableForNextRequest;
};

const getCompletedDataAvailableStatus = (state) => {
  const { dataAvailableForNextRequest } = getCompletedContributions(state);
  return dataAvailableForNextRequest;
};
/** Lazy loading selectors */

/** 1year Graph Data selectors */

const getOneYearContributions = (state) => {
  const { contributionDashboard_data } = getContributionDashboardStates(state);
  return contributionDashboard_data;
};

const getOneYearContributionsLoadingStatus = (state) => {
  const { isLoadingBot } = getOneYearContributions(state);
  return isLoadingBot;
};

const getOneYearContributionsData = (state) => {
  const { data } = getOneYearContributions(state);
  return data;
};

const getOneYearY3Flag = (state) => {
  const { data_y3 } = getOneYearContributions(state);
  return data_y3;
};

const getOneYearY5Flag = (state) => {
  const { data_y5 } = getOneYearContributions(state);
  return data_y5;
};

const getBotText = (state) => {
  const { botStatusText } = getOneYearContributions(state);
  return botStatusText;
};

/** 1year Graph Data selectors */

/** 5year Graph Data selectors */

const getFiveYearContributions = (state) => {
  const { contributionDashboard_data_all } = getContributionDashboardStates(
    state
  );
  return contributionDashboard_data_all;
};

const getFiveYearContributionsLoadingStatus = (state) => {
  const { isLoadingBot } = getFiveYearContributions(state);
  return isLoadingBot;
};

const getFiveYearContributionsData = (state) => {
  const { data } = getFiveYearContributions(state);
  return data;
};

const getFiveYearY3Flag = (state) => {
  const { data_y3 } = getFiveYearContributions(state);
  return data_y3;
};

const getFiveYearY5Flag = (state) => {
  const { data_y5 } = getFiveYearContributions(state);
  return data_y5;
};

/** 5year Graph Data selectors */

/** Chart Data */

const getChartData = (state) => {
  const { chartData } = getContributionDashboardStates(state);
  return chartData;
};

const getShowChartStatus = (state) => {
  const { show } = getChartData(state);
  return show;
};

const getShowChartLoadingStatus = (state) => {
  const { isLoading } = getChartData(state);
  return isLoading;
};

const getSelectedCompletedContribution = (state) => {
  const { data } = getChartData(state);
  return data;
};

const getSelectedCompletedContributionError = (state) => {
  const { error } = getChartData(state);
  return error;
};

/** Chart Data */

/** Initial Contributions tab Data */

const getInitialPendingData = (state) => {
  const { initialPendingData } = getContributionDashboardStates(state);
  return initialPendingData;
};

const getInitialCompletedData = (state) => {
  const { initialCompletedData } = getContributionDashboardStates(state);
  return initialCompletedData;
};

/** Initial Contributions tab Data */

/** Value Your Contributions Data */

const getValueYourContributions = (state) => {
  const { value_your_contributions } = getContributionDashboardStates(state);
  return value_your_contributions;
};

const getValueYourContributionsLoadingStatus = (state) => {
  const { isLoading } = getValueYourContributions(state);
  return isLoading;
};

const getValueYourContributionsError = (state) => {
  const { valueYourContributionsError } = getValueYourContributions(state);
  return valueYourContributionsError;
};

const getValueYourContributionsData = (state) => {
  const { data } = getValueYourContributions(state);
  return data;
};

/** Value Your Contributions Data */

/** YTD Data */

const getYTD = (state) => {
  const { ytdData } = getContributionDashboardStates(state);
  return ytdData;
};

const getYTDData = (state) => {
  const { data } = getYTD(state);
  return data;
};

const getYTDError = (state) => {
  const { error } = getYTD(state);
  return error;
};

const getYTDLoadingStatus = (state) => {
  const { isLoading } = getYTD(state);
  return isLoading;
};

/** YTD Data */

/** Messaging Data */
const getEstablishedDate = (state) => {
  const { messages } = getMessagingStates(state);
  return messages.additionalAccountDetails;
};
/** Messaging Data */

export const contributionsDashboardStates = createStructuredSelector({
  accData: getAccountData,
  accIsLoading: getAccountLoadingStatus,
  accIsError: getAccountError,
  pendingContributions: getPendingContributionsData,
  isLoadingPendingContribution: getPendingContributionsLoadingStatus,
  completedContributions: getCompletedContributionsData,
  isLoadingCompletedContributions: getCompletedContributionsLoadingStatus,
  taxReceipts: getTaxReceiptsData,
  isLoadingTaxReceipts: getTaxReceiptsLoadingStatus,
  accountID: selectAccountID,
  isLazyLoading: getLazyLoadingStatus,
  pendingDataAvailable: getPendingDataAvailableStatus,
  completedDataAvailable: getCompletedDataAvailableStatus,
  isContributionLoading: getOneYearContributionsLoadingStatus,
  contributionsData: getOneYearContributionsData,
  data_y3: getOneYearY3Flag,
  data_y5: getOneYearY5Flag,
  data_all_y3: getFiveYearY3Flag,
  data_all_y5: getFiveYearY5Flag,
  isAllContributionLoading: getFiveYearContributionsLoadingStatus,
  allContributionsData: getFiveYearContributionsData,
  botStatusText: getBotText,
  showData: getShowChartStatus,
  isLoadingContributions: getShowChartLoadingStatus,
  selectedCompletedContributions: getSelectedCompletedContribution,
  selectedCompletedContributionsError: getSelectedCompletedContributionError,
  pendingPagination: getInitialPendingData,
  completedPagination: getInitialCompletedData,
  carouselData: getCarouselData,
  valueYourContributionsIsLoading: getValueYourContributionsLoadingStatus,
  valueYourContributionsError: getValueYourContributionsError,
  valueYourContributions: getValueYourContributionsData,
  ytdData: getYTDData,
  ytdError: getYTDError,
  ytdIsLoading: getYTDLoadingStatus,
  establishedDate: getEstablishedDate,
});
